module.exports = __webpack_public_path__ + "img/temperature-goal-slide1.9f9c9dc8.gif";